import { ApolloError } from '@apollo/client';

type MaybeArray<T> = T | Array<T> | ReadonlyArray<T>;

// In reality, the following object should look like:
// { message: "...", extensions: { code: "INTERNAL_SERVER_ERROR", exception: { code: "QUERY_REJECTED", name: "UniqueConstraintViolationError", stacktrace: ["..."] } }, path: ["createJob"] }
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type GraphQLErrorObject = {
  message: string;
  extensions?: {
    code?: string;
    exception?: ObjectOf<unknown>;
  };
  path?: ReadonlyArray<string>;
};

// TODO: Extract a more useful error message from
// apolloError.graphQLErrors[0].extensions.exception. We can probably check the
// name property against a list of known errors from the server and even
// localize those once we get more i18n infrastructure in place.
export function parseApolloError(input: MaybeArray<ApolloError>): string {
  let error = Array.isArray(input) ? input[0] : input;
  if (error instanceof ApolloError) {
    let { networkError, graphQLErrors, clientErrors } = error;
    let errors = networkError
      ? [networkError]
      : clientErrors.length
      ? clientErrors
      : graphQLErrors;
    if (errors[0]) {
      return errors[0].message;
    } else {
      return error.message;
    }
  }
  return error instanceof Error ? error.message : String(error);
}
